<agr-page>
  <mat-vertical-stepper linear id="stepper">
    <mat-step [stepControl]="applicationFormGroup">
      <form [formGroup]="applicationFormGroup">
        <ng-template matStepLabel>{{ 'wizard_step1SelectApplication' | translate }}</ng-template>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'wizard_application' | translate }}</mat-label>
          <mat-select formControlName="appNameCtrl" required>
            <mat-option *ngFor="let application of applications$ | async" [value]="application">
              {{ application.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button color="primary" mat-button matStepperNext>{{ 'wizard_next' | translate }}</button>
        </div>
      </form>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step2DeleteApplication' | translate }}</ng-template>
      <p>{{ 'wizard_youAreAboutToDelete' | translate }}</p>
      <ul class="app-highlights">
        <li>
          {{ 'wizard_theApplication' | translate }}
          <b>{{ applicationFormGroup.get('appNameCtrl').valueChanges | async }}</b>
        </li>
      </ul>
      <div>
        <button mat-button matStepperPrevious>{{ 'wizard_back' | translate }}</button>
        <button mat-button (click)="stepper.reset()">{{ 'wizard_reset' | translate }}</button>
        <button mat-button color="primary" (click)="complete()">
          {{ 'wizard_complete' | translate }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'wizard_step3Complete' | translate }} </ng-template>
      <p>{{ 'wizard_deleteApplicationSuccessMessage' | translate }}</p>
    </mat-step>
  </mat-vertical-stepper>
</agr-page>
